import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InbOrd01Actions, { InbOrd01Types } from '../Stores/InbOrd01/Actions';

const getAppStore = state => state.app;

export function* inbOrd01FetchInbOrd01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InbOrd01Actions.inbOrd01FetchInbOrd01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `inbOrd/indexProcess/INB_ORD_01/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InbOrd01Actions.inbOrd01FetchInbOrd01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01FetchInbOrd01Loading(false));
  }
}

export function* inbOrd01CreateInbOrd01({ hdrIds }) {
  try {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `inbOrd/createProcess/INB_ORD_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(false));
  }
}

export function* inbOrd01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/advShipDetail/update/${hdrId}`));
}

export function* inbOrd01NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/advShipDetail/create/${app.curDivisionId}`));
}

export function* inbOrd01ShowDetails({ hdrId }) {
  try {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(true));

    let result = {
      isSuccess: true,
      data: []
    };

    if (hdrId > 0) {
      const app = yield select(getAppStore);
      const getData = {};

      result = yield call(
        ApiService.getApi, // function
        app.apiUrl,
        `advShip/showDetails/${hdrId}`,
        app.token,
        getData,
        'multipart/form-data' // params
      );
    }

    if (result.isSuccess === true) {
      yield put(InbOrd01Actions.inbOrd01ShowDetailsSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(false));
  }
}

export function* inbOrd01CreateInbOrd01Partial({ formikBag, hdrId, documentDetails }) {
  formikBag.setSubmitting(true);
  try {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrId,
      details: documentDetails
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `inbOrd/createProcessPartial/INB_ORD_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd01Actions.inbOrd01CreateInbOrd01PartialSuccess(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(false));
    formikBag.setSubmitting(false);
  }
}

export function* inbOrd01CloseDocument({ hdrId }) {
  try {
    yield put(InbOrd01Actions.inbOrd01FetchInbOrd01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrId,
      docStatus: 'CLOSE_PARTIAL_QTY'
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      'advShip/transitionToStatus',
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd01Actions.inbOrd01ResetTimestamp());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01FetchInbOrd01Loading(false));
  }
}

export function* inbOrd01TransitionToDraft({ hdrIds }) {
  try {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      'advShip/transitionAllToDraft',
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Success([]));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd01Actions.inbOrd01CreateInbOrd01Loading(false));
  }
}

export const saga = [
  takeLatest(InbOrd01Types.INB_ORD01_FETCH_INB_ORD01, inbOrd01FetchInbOrd01),
  takeLatest(InbOrd01Types.INB_ORD01_CREATE_INB_ORD01, inbOrd01CreateInbOrd01),
  takeLatest(InbOrd01Types.INB_ORD01_GO_TO_DOCUMENT, inbOrd01GoToDocument),
  takeLatest(InbOrd01Types.INB_ORD01_NEW_DOCUMENT, inbOrd01NewDocument),

  takeLatest(InbOrd01Types.INB_ORD01_SHOW_DETAILS, inbOrd01ShowDetails),
  takeLatest(InbOrd01Types.INB_ORD01_CREATE_INB_ORD01_PARTIAL, inbOrd01CreateInbOrd01Partial),
  takeLatest(InbOrd01Types.INB_ORD01_CLOSE_DOCUMENT, inbOrd01CloseDocument),

  takeLatest(InbOrd01Types.INB_ORD01_TRANSITION_TO_DRAFT, inbOrd01TransitionToDraft)
];
